module.exports = __webpack_public_path__ + "static/logo-ff109e4b8fba69a331a2c1a28669c272.png";